import type React from "react";
import { Box, Group, Stack, Text } from "@mantine/core";
import HeroArt from "@components/HeroArt";

const SearchHero: React.FC = () => {
  return (
    <Box w="100%" maw={1100}>
      <Group justify="space-between" align="center" wrap="nowrap" gap="xl">
        <Stack gap="md" maw={560}>
          <Text size="xl" fw={800} component="h1" c="var(--mantine-color-text)">
            Turn questions into sourced answers
          </Text>
          <Text c="dimmed" size="md">
            IntelliSearch turns a plain-language question into the exact
            procedure, repair time, or part across TecAlliance&apos;s data. It
            expands, retrieves, and re-ranks with an LLM, so every result comes
            back scored and linked to its source.
          </Text>
        </Stack>

        <Box visibleFrom="md" >
          <HeroArt />
        </Box>
      </Group>
    </Box>
  );
};

export default SearchHero;
